export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-emerald-800 to-teal-900 text-white py-8 sm:py-12 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Logo & About */}
          <div className="sm:col-span-2">
            <div className="flex items-center gap-3 mb-3 sm:mb-4">
              <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/3294a4af19582454411e375cbd1c78be/a19a10601520d1fc990e87845b2a9082.png"
                  alt="PBPKNM Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <div className="text-lg sm:text-xl font-bold">PBPKNM</div>
                <div className="text-xs sm:text-sm text-emerald-200">Kempen Infaq Ramadhan & Raya</div>
              </div>
            </div>
            <p className="text-emerald-100 text-xs sm:text-sm leading-relaxed mb-3 sm:mb-4">
              Membantu bekas anggota pasukan keselamatan negara melalui kempen infaq bakul makanan sempena Ramadhan dan Hari Raya Aidilfitri.
            </p>
            <div className="flex gap-2 sm:gap-3">
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-base sm:text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-base sm:text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base sm:text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-base sm:text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">Pautan Pantas</h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <a href="#pengenalan" className="text-emerald-200 hover:text-white transition-colors cursor-pointer">
                  Pengenalan
                </a>
              </li>
              <li>
                <a href="#matlamat" className="text-emerald-200 hover:text-white transition-colors cursor-pointer">
                  Matlamat
                </a>
              </li>
              <li>
                <a href="#pakej" className="text-emerald-200 hover:text-white transition-colors cursor-pointer">
                  Pakej Bakul
                </a>
              </li>
              <li>
                <a href="#sasaran" className="text-emerald-200 hover:text-white transition-colors cursor-pointer">
                  Sasaran Penerima
                </a>
              </li>
              <li>
                <a href="#infaq" className="text-emerald-200 hover:text-white transition-colors cursor-pointer">
                  Infaq Sekarang
                </a>
              </li>
              <li>
                <a href="#hubungi" className="text-emerald-200 hover:text-white transition-colors cursor-pointer">
                  Hubungi Kami
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">Hubungi</h4>
            <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-emerald-300 mt-1"></i>
                <span className="text-emerald-200 break-all">info@pbpknm.org.my</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-whatsapp-line text-emerald-300 mt-1"></i>
                <span className="text-emerald-200">+60 12-345 6789</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-emerald-300 mt-1"></i>
                <span className="text-emerald-200">Kuala Lumpur, Malaysia</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-emerald-700 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4 text-xs sm:text-sm text-emerald-200">
            <div className="text-center sm:text-left">
              © 2025 PBPKNM. Hak Cipta Terpelihara.
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 text-center">
              <span>Semoga setiap infaq diberkati Allah SWT</span>
              <span className="hidden sm:inline">•</span>
              <span>Powered by GrakXpert</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
